import { useQueryIntegrationCapabilities } from '@/hooks/query/integrations/general/useQueryIntegrationCapabilities';
import { type EHRProvider } from '@heidi/schema/ml-scribe';

export const useIntegrationCapabilityResolver = ({
  isGenericEhrLaunch,
  genericLaunchEhrProvider,
  onboardingSessionProvider,
}: {
  isGenericEhrLaunch: boolean;
  genericLaunchEhrProvider?: EHRProvider;
  onboardingSessionProvider?: EHRProvider;
}) => {
  const capabilityProvider = isGenericEhrLaunch
    ? genericLaunchEhrProvider
    : onboardingSessionProvider;

  // `isLoading` (not `isPending`) is false when the query is disabled — i.e. for
  // accounts with no capabilityProvider — so a non-integration surface is never
  // treated as still-resolving. A disabled query also never errors, so `isError`
  // stays false there too.
  const {
    data: integrationCapabilities,
    isLoading: isCapabilitiesPending,
    isError: isCapabilitiesError,
  } = useQueryIntegrationCapabilities(capabilityProvider);

  return {
    capabilityProvider,
    integrationCapabilities,
    isCapabilitiesPending,
    isCapabilitiesError,
  };
};
